import React from 'react';

import { NotifyModal } from 'components';

const CreateUserModal = ({ onCancel, onConfirm }) => {
  return (
    <NotifyModal
      open
      title="Create user without a license?"
      cancelText="Yes, create user"
      confirmText="No, assign license"
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      <div className="m-notify-modal">
        <div
          className="m-notify-modal__main"
          data-testid="PlatformAdminUI-Users-CreateUserModal-Body"
        >
          Users without a license assigned will have limited capabilities within
          the platform.
        </div>
        <div>
          Are you sure you would like to create this user without a license?
        </div>
      </div>
    </NotifyModal>
  );
};

export default CreateUserModal;
